import { LazyAction, LazyModule } from 'owa-bundling';

const lazyIndex = new LazyModule(() => import(/* webpackChunkName: "OwsGateway" */ './lazyIndex'));

export { gulpParam, owsServerParam, owsApiParam, HttpMethod, PrimeServiceError } from './constants';

type lazyType = typeof import('./lazyIndex');

// OW 55102. We have to cast this functions because LazyAction has a bug where it doesn't assign the
// correct types with function that return any or Promise<any>
let makeOwsPrimeRequest = <(...args: Parameters<lazyType['makeOwsPrimeRequest']>) => Promise<any>>(
    new LazyAction(lazyIndex, m => m.makeOwsPrimeRequest).importAndExecute
);
let makePostRequest = <(...args: Parameters<lazyType['makePostRequest']>) => Promise<any>>(
    new LazyAction(lazyIndex, m => m.makePostRequest).importAndExecute
);
let makePatchRequest = <(...args: Parameters<lazyType['makePatchRequest']>) => Promise<any>>(
    new LazyAction(lazyIndex, m => m.makePatchRequest).importAndExecute
);
let makePutRequest = <(...args: Parameters<lazyType['makePutRequest']>) => Promise<any>>(
    new LazyAction(lazyIndex, m => m.makePutRequest).importAndExecute
);
let makeGetRequest = <(...args: Parameters<lazyType['makeGetRequest']>) => Promise<any>>(
    new LazyAction(lazyIndex, m => m.makeGetRequest).importAndExecute
);
let makeDeleteRequest = <(...args: Parameters<lazyType['makeDeleteRequest']>) => Promise<any>>(
    new LazyAction(lazyIndex, m => m.makeDeleteRequest).importAndExecute
);
export {
    makeOwsPrimeRequest,
    makePostRequest,
    makePatchRequest,
    makePutRequest,
    makeGetRequest,
    makeDeleteRequest,
};
